import {tx, ptx, usePageText} from '../lib/page-text';
import { AnalyticsReport } from './AnalyticsReport';
export function EventReports({ stream }: { stream: { id: string } }) {
  usePageText();
  return <div><h2>{tx("Event reports")}</h2><p className="muted">{tx("Broadcast activity and audience engagement for this stream.")}</p><AnalyticsReport streamId={stream.id} /></div>;
}
